import { z } from "zod"

import { powurOsAdderSchema } from "./adders"

export const powurOsAdderRegionAdderSchema = z.object({
  id: z.number().int(),
  adderId: z.number().int(),
  adder: powurOsAdderSchema.optional(),
  adderRegionId: z.number().int(),
  proposalType: z.number(),
})

export type PowurOsAdderRegionAdder = z.infer<
  typeof powurOsAdderRegionAdderSchema
>
